import React, { useEffect, useRef } from 'react';
import { signOut } from '../../../auth/sso';

// Internal-SSO logout — local session cleared FIRST and unconditionally, then redirect to
// the auth site's /logout?return_to=<origin> to revoke the Stytch session. Goes through
// signOut() so the route guard and the API adapters stand down instead of racing the
// redirect with an authorize redirect of their own.
//
// Routed at /SignOut/* as a SIBLING of the authenticated subtree, never below it: under
// the guard it would not mount once the session was already gone, and sign-out would
// silently not happen for exactly the users who most need it to.
export function SignOut() {
  // The redirect is a side effect, so it belongs in an effect rather than the render body;
  // StrictMode double-invokes effects in dev, so guard it to run exactly once.
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;
    signOut();
  }, []);

  return (
    <p role="status" aria-live="polite">
      Signing you out…
    </p>
  );
}
